import { parseRoute } from "./parseRoute";

export interface RouteMatcher {
  getPathParams: (pathname: string) => Record<string, string | Array<string>>;
  findMatchingPattern: (pathname: string) => string | undefined;
}

export const createRouteMatcher = (routes: Array<string>): RouteMatcher => {
  const parsedRoutes = routes
    .map(parseRoute)
    .sort((a, b) => b.priority - a.priority);

  return {
    getPathParams: (pathname) => {
      for (const route of parsedRoutes) {
        const pathParams = route.getPathParams(pathname);
        if (pathParams) {
          return pathParams;
        }
      }
      return {};
    },
    findMatchingPattern: (pathname) => {
      const { route } =
        parsedRoutes.find((route) => route.test(pathname)) || {};
      return route;
    },
  };
};
